// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getPartReturn} from '../../shared/repositories';
import {updateInfoRequestForm} from './information-request-form';
import {updatePartRequestForm} from './part-request-form';
import {updatePictRequestForm} from './picture-request-form';

export const readRequestDetails = id =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const partReturn = await getPartReturn(id);

            dispatch({
                partReturn,
                type: actions.UPDATE_REQUEST_DETAILS_PART_RETURN
            });

            const updateFormType = {
                INFO: updateInfoRequestForm,
                PART: updatePartRequestForm,
                PICT: updatePictRequestForm
            };

            updateFormType[partReturn.requestType.key](partReturn)(dispatch, getState);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/get-request-details.js